import { NavLink } from 'react-router-dom';
import { Home, PenLine, Mail, User, Waves } from 'lucide-react';
import { useCopy } from '../../copy';
import { OPP_PRIMARY_NAVIGATION, type OppPrimaryNavigationId } from '../../config/primaryNavigation';

const ICONS: Record<OppPrimaryNavigationId, typeof Home> = {
  home: Home,
  letters: Mail,
  write: PenLine,
  drift: Waves,
  me: User,
};

export default function BottomNav() {
  const { t } = useCopy();

  const tabs = OPP_PRIMARY_NAVIGATION.map((tab) => ({
    ...tab,
    icon: ICONS[tab.id],
    isFab: tab.id === 'write',
    label: t(tab.key),
  }));

  return (
    <nav
      aria-label="主导航"
      className="opp-material opp-shell-mobile-tabbar opp-shell-tabbar fixed inset-x-0 bottom-0 z-50"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="opp-shell-horizontal mx-auto flex h-[var(--opp-tabbar-height)] max-w-md items-end justify-around pb-1 pt-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;

          if (tab.isFab) {
            return (
              <NavLink
                key={tab.id}
                to={tab.href}
                end
                aria-label={tab.label}
                className={({ isActive }) => `relative -mt-4 flex min-h-12 min-w-16 flex-col items-center justify-end rounded-2xl touch-manipulation focus-visible:outline-none ${isActive ? 'text-[hsl(var(--opp-accent-strong))]' : 'text-[hsl(var(--opp-muted))]'}`}
              >
                <div
                  className="flex items-center justify-center rounded-full border border-on-image/30 bg-[hsl(var(--opp-accent))] shadow-opp-fab transition-transform duration-150 active:scale-95"
                  style={{ width: 'var(--litopia-layout-3-dot-25rem)', height: 'var(--litopia-layout-3-dot-25rem)' }}
                >
                  <Icon className="h-5 w-5 text-[hsl(var(--opp-accent-foreground))]" />
                </div>
                <span className="mt-1 text-caption font-semibold">
                  {tab.label}
                </span>
              </NavLink>
            );
          }

          return (
            <NavLink
              key={tab.id}
              to={tab.href}
              end={tab.href === '/'}
              aria-label={tab.label}
              className={({ isActive }) => `relative flex min-h-12 min-w-14 touch-manipulation flex-col items-center justify-center rounded-2xl px-2 py-1 transition-[color,background-color,transform] duration-150 active:scale-95 ${isActive ? 'bg-[hsl(var(--opp-accent-soft)/.72)] text-[hsl(var(--opp-accent-strong))]' : 'text-[hsl(var(--opp-muted))]'}`}
            >
              <Icon className="h-5 w-5" />
              <span className="mt-1 text-caption font-medium">
                {tab.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
